export const padTime = (n: number): string => n.toString().padStart(2, '0')
